import axios from "axios";
import { storage } from "@/lib/storage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const opts = { withCredentials: true };

export const authApi = {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  login(role) {
    if (role) sessionStorage.setItem("opg_pending_role", role);
    const redirectUrl = window.location.origin + "/merchant";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  },
  exchange: (sessionId) => axios.post(`${API}/auth/session`, { session_id: sessionId }, opts),
  me: () => axios.get(`${API}/auth/me`, opts),
  async logout() {
    try {
      await axios.post(`${API}/auth/logout`, {}, opts);
    } catch (e) {
      // offline: still sign out locally
    }
    storage.clearUser();
    storage.lock();
  },
};
